/**
 * Portal Manta · TabelaKPIs
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { Fonte } from '../shared/ArtefatoHelpers.jsx';
import { LinhaTabelaKPI } from './LinhaTabelaKPI.jsx';

const TabelaKPIs = memo(function TabelaKPIs_Inner({titulo, schema, valores, fontes, onChange, onLimpar}){
  // Achatar campos do schema preservando bloco
  const linhas = [];
  Object.entries(schema).forEach(([blocoKey, bloco], blocoIdx) => {
    bloco.campos.forEach(c => {
      linhas.push({
        ...c,
        blocoLabel: bloco.titulo.split('·')[0].trim(), // "A" do "A · Identificação"
        blocoIcone: bloco.icone,
      });
    });
  });

  // Contagem
  const totalCampos = linhas.length;
  const preenchidos = linhas.filter(c => {
    const v = valores[c.k];
    return v !== undefined && v !== null && v !== '' && v !== 0;
  }).length;
  const pctPreench = Math.round((preenchidos / totalCampos) * 100);

  // Estilo Excel · zebra clara
  const thStl = {
    padding:'5px 8px', background:'#F3F4F6', color:M.title,
    fontWeight:700, fontSize:10.5, fontFamily:F.mono, letterSpacing:.5, textTransform:'uppercase',
    border:`1px solid ${M.border}`, textAlign:'left', position:'sticky', top:0, zIndex:1,
  };
  const tdStl = {
    padding:'2px 6px', border:`1px solid ${M.borderSoft}`,
    fontSize:11.5, color:M.text, verticalAlign:'middle',
  };

  return (<div style={{marginBottom:20, border:`1px solid ${M.border}`, borderRadius:4, overflow:'hidden', background:'#fff'}}>
    {/* Header do quadro */}
    <div style={{
      padding:'8px 12px', background:M.title, color:'#fff',
      display:'flex', alignItems:'center', gap:10, borderBottom:`2px solid ${M.accent}`,
    }}>
      <span style={{fontSize:14}}>📊</span>
      <div style={{flex:1, fontFamily:F.display, fontWeight:600, fontSize:13, letterSpacing:.4}}>
        {titulo}
      </div>
      <div style={{fontSize:10.5, fontFamily:F.mono, opacity:.85}}>
        <span style={{color: pctPreench>70 ? '#86EFAC' : (pctPreench>30 ? '#FCD34D' : '#FCA5A5')}}>
          {preenchidos}/{totalCampos}
        </span>
        {' '}({pctPreench}%)
      </div>
    </div>

    {/* Tabela */}
    <div style={{overflow:'auto', maxHeight:420}}>
      <table style={{width:'100%', borderCollapse:'collapse', fontFamily:F.body}}>
        <thead>
          <tr>
            <th style={{...thStl, width:36, textAlign:'center'}}>#</th>
            <th style={{...thStl, width:50, textAlign:'center'}}>Bloco</th>
            <th style={{...thStl, width:'34%'}}>Campo</th>
            <th style={{...thStl, width:70, textAlign:'center'}}>Unidade</th>
            <th style={{...thStl}}>Valor</th>
            <th style={{...thStl, width:80, textAlign:'center'}}>Fonte</th>
            <th style={{...thStl, width:36, textAlign:'center'}}> </th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((c, idx) => (
            <LinhaTabelaKPI
              key={c.k}
              campo={c}
              idx={idx}
              valor={valores[c.k]}
              fonte={fontes[c.k]}
              onChange={onChange}
              onLimpar={onLimpar}
              tdStl={tdStl}
            />
          ))}
        </tbody>
      </table>
    </div>
  </div>);
});

export { TabelaKPIs };
export default TabelaKPIs;
